import { HttpClient } from  '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Stakeholder } from '../models/stakeholder.model';
import { environment } from 'src/environments/environment';
import { HpDataProviderService } from './hp-data-provider.service';

@Injectable({
  providedIn: 'root'
})
export class StakeholderService {
  private http = inject(HttpClient);
  private hpDataProviderService = inject(HpDataProviderService);


  public getStakeholders() {
    return this.http.get<Stakeholder[]>(`${environment.API_URL}/stakeholder/${this.getHpId()}/stakeholders`);
  }

  public insertStakeholders(stakeholders: Stakeholder[]) {
    return this.http.post<any>(`${environment.API_URL}/stakeholder/list`, { stakeholders, hpId: this.getHpId() });
  }

  public inviteStakeholders() {
    return this.http.post<any>(`${environment.API_URL}/stakeholder/invite`, { hpId: this.getHpId() });
  }

  private getHpId(): number {
    const id = this.hpDataProviderService.getHp()?.hpId;
    if(id === undefined){
      throw new Error('Hp is undefined');
    }
    return id;
  }
}
